module.exports = __webpack_public_path__ + "static/2-adf5eff6d3d4747a7e81382a60e77df1.jpg";